export enum SAILTHRU_COOKIE_NAMES {
    SAILTHRU_HID = 'sailthru_hid',
    SAILTHRU_NO_COOKIES = 'sailthru_no_cookies',
}

export enum SAILTHRU_COOKIE_VALUES {
    DO_NOT_TRACK = 'do-not-track',
    SAILTHRU_NO_COOKIES_ON = 1,
    SAILTHRU_NO_COOKIES_OFF = 0,
}

export enum SAILTHRU_INTEGRATION_ACTIONS {
    PURCHASE = 'purchase',
    USER_SIGN_UP = 'userSignUp',
}

export enum SAILTHRU_TRACK_ACTIONS {
    DO_NOT_TRACK_USER = 'cookiesDoNotTrack',
}

export enum SAILTHRU_USER_LIST_ACTIONS {
    REMOVE,
    ADD,
}

export enum SAILTHRU_USER_LISTS {
    EVERGREEN_LIST = 'Evergreen email capture',
    MASTER_LIST = 'Master List',
}

export const SAILTHRU_SCRIPT_TAG_ID: string = 'oz-sailthru-load';
